const isLearning = process.env.VUE_APP_MODE === 'learning'

const learningModeHostname = process.env.VUE_APP_LEARNING_HOSTNAME

const normalModeHostname = process.env.VUE_APP_NORMAL_HOSTNAME

export { isLearning, learningModeHostname, normalModeHostname }
